import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { CmsBannerComponent } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { UserInfoService } from '../../spartacus/services/user-info.service';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-new-orders',
    templateUrl: './new-orders.component.html',
    styleUrls: ['./new-orders.component.scss'],
    standalone: false
})
export class NewOrdersComponent implements OnInit {
  constructor(public component: CmsComponentData<CmsBannerComponent>,private cdr:ChangeDetectorRef,
    public userInfoService:UserInfoService) {}
    bannerNode: Observable<any> = this.component.data$;
    seasonData:any;
    //seasonData :Observable<any> =  this.userInfoService.getseasonDropdown("2024-2025");
    @Input() orderSummary : Observable<any>= this.userInfoService.getOrderSummary();
    percDelivered:any;
    percInTransit:any;
    percProcessed:any;
    productsArray:any;
  ngOnInit(): void {
    
    this.userInfoService.getseasonDropdown("2024-2025").subscribe(value=>{
      this.seasonData=value
      this.userInfoService.setorderseaosn(this.seasonData?.inSeason);
      this.cdr.detectChanges();
    })
  }
   
  getProductsArray1(data:any){
     return data.products.filter((res:any) =>res.baseName == 'Flucelvax');
  }
  getProductsArray2(data:any){
    return data.products.filter((res:any) =>res.baseName == 'Fluad');
  }
  getProductsArray3(data:any){          
    return data.products.filter((res:any) =>res.baseName == 'Afluria');
  }
}
